var exports = {
  "container": "x24da60e8--3a0351--container",
  "phone": "x24da60e8--3a0351--phone",
  "tablet": "x24da60e8--3a0351--tablet",
  "content": "x24da60e8--3a0351--content",
  "top-block": "x24da60e8--3a0351--top-block",
  "about": "x24da60e8--3a0351--about",
  "title": "x24da60e8--3a0351--title",
  "logo": "x24da60e8--3a0351--logo",
  "logo-link": "x24da60e8--3a0351--logo-link",
  "links": "x24da60e8--3a0351--links",
  "contacts": "x24da60e8--3a0351--contacts",
  "city": "x24da60e8--3a0351--city",
};

module.exports = exports;
